document.addEventListener("DOMContentLoaded", function () {
  const addToCartForm = document.querySelector('form[action*="/cart/add"]');
  const stickyBar = document.getElementById("sticky-add-to-cart");
  const stickyButton = document.getElementById("sticky-add-btn");
  const confirmMsg = document.getElementById("sticky-confirm");

  if (!addToCartForm || !stickyBar) return;

  // Show sticky bar when normal Add to Basket scrolls out of view
  window.addEventListener("scroll", () => {
    const rect = addToCartForm.getBoundingClientRect();
    stickyBar.classList.toggle("hidden", rect.top > 0);
  });

  // Handle Add to Basket click
  stickyButton.addEventListener("click", () => {
    const submitButton = addToCartForm.querySelector('[type="submit"]');
    if (submitButton) submitButton.click();

    // Show confirmation message briefly
    confirmMsg.classList.remove("hidden");
    setTimeout(() => {
      confirmMsg.classList.add("hidden");
    }, 2000);
  });
});
